<template>
  <div>
    <div
      class="text-xs-center pa-2"
      style="border: 1px solid #eee; float: left; border-radius: 10px"
    >
      <template v-if="baseUrl">
        <img style="width: 100%; max-width: 255px" ref="answer" :src="baseUrl" />
      </template>
      <div class="primary--text caption">Line Image Map</div>
      <v-btn color="primary" depressed @click="show = true">{{ $t('Edit') }}</v-btn>
      <v-dialog v-model="show" width="1000">
        <v-card>
          <v-layout>
            <v-flex>
              <div class="primary--text headline pa-2">Line Image Map</div>
            </v-flex>
            <v-flex>
              <div class="text-xs-right">
                <v-btn flat fab small @click="oncancel">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>

          <v-card-text>
            <intent-line-image-map-message v-model="message"></intent-line-image-map-message>
          </v-card-text>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="oncancel">{{ $t('Cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="onsave">{{ $t('Save') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="clearfix"></div>
    <div class="caption mt-2 warning--text">
      {{ $t('Note: This messages will not be shown on facebook') }}
    </div>
  </div>
</template>

<script>
import IntentLineImageMapMessage from './IntentLineImageMapMessage'
import jsonFormatter from 'json-string-formatter'
export default {
  props: ['value'],
  data: function () {
    return {
      show: false,
      message: null,
      baseUrl: null,
    }
  },
  components: {
    IntentLineImageMapMessage,
  },
  mounted: function () {
    var vm = this
    vm.baseUrl = vm.value.baseUrl
    vm.message = jsonFormatter.format(JSON.stringify(vm.value))
    vm.cached_message = jsonFormatter.format(JSON.stringify(vm.value))
  },
  methods: {
    oncancel: function () {
      this.show = false
      this.message = this.cached_message
    },
    onsave: function () {
      var vm = this

      vm.$emit('input', JSON.parse(vm.message))
      vm.message = jsonFormatter.format(vm.message)
      vm.show = false
      vm.cached_message = vm.message
    },
  },
  watch: {
    value: function (newVal) {
      var vm = this
      vm.baseUrl = newVal.baseUrl
      this.message = jsonFormatter.format(JSON.stringify(newVal))
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentLineImageMap.vue